var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 900.65332,
    height: 471.07999,
    viewBox: "0 0 900.65332 471.07999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "group-R5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m 367.281,1932.8 c 108.215,-180.36 308.254,-301.7 573.875,-301.7 252.504,0 341.044,118.06 341.044,226.27 0,200.04 -255.78,249.23 -573.872,367.28 -327.93,118.06 -554.199,295.14 -554.199,662.42 0,409.91 367.277,646.02 787.027,646.02 386.954,0 623.064,-183.64 764.074,-380.4 l -337.77,-268.9 c -81.98,114.78 -216.43,196.76 -413.187,196.76 -186.918,0 -301.695,-78.71 -301.695,-186.92 0,-190.2 180.363,-196.76 550.922,-341.04 413.19,-157.41 583.71,-350.89 583.71,-678.82 0,-403.35 -268.9,-698.49 -849.331,-698.49 -491.895,0 -796.867,229.55 -937.879,505.01 l 367.281,252.51",
    style: {
      fill: "#232221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3",
    d: "M 3177.65,2864.1 2731.66,1762.26 2292.24,2864.1 h -508.29 l 691.93,-1682.27 -167.42,-382.408 752.88,596.778 624.6,1467.9 h -508.29",
    style: {
      fill: "#232221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M 4095.41,2421.41 H 3875.7 v 442.7 h 219.71 v 632.91 h 475.5 v -632.91 h 364 v -442.7 h -364 V 1170.03 h -475.5 v 1251.38",
    style: {
      fill: "#232221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5",
    d: "m 6263.03,2227.93 c 0,150.85 -160.69,275.46 -357.45,275.46 -213.15,0 -386.95,-121.33 -400.07,-275.46 z M 5010.34,2041.01 c 0,527.97 380.39,865.74 895.24,865.74 511.57,0 849.34,-373.84 849.34,-839.5 0,0 0,-81.98 -6.56,-157.41 H 5498.95 c 9.84,-196.75 180.36,-324.65 439.43,-324.65 170.52,0 288.57,52.47 403.35,160.69 l 285.3,-272.18 C 6407.32,1247.43 6167.93,1172 5915.42,1172 c -537.8,0 -905.08,337.77 -905.08,855.9 v 13.11",
    style: {
      fill: "#232221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "m 2210.24,575.172 7.78,6.168 749.3,593.94 -255.35,-600.108",
    style: {
      fill: "#f4c80d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "m 3489.6,222.469 c 39.31,0 68.04,27.972 68.04,64.25 0,35.531 -27.97,61.992 -68.79,61.992 h -99.78 V 222.469 Z m -24.18,216.191 c 33.26,0 56.69,23.43 56.69,55.942 0,30.988 -23.43,54.418 -55.94,54.418 h -77.1 V 438.66 Z m -190.49,210.141 h 209.39 c 83.9,0 150.42,-56.692 150.42,-134.551 0,-50.648 -24.94,-90.711 -67.28,-105.832 69.55,-12.09 105.84,-65 105.84,-130.77 0,-89.199 -68.04,-155.707 -160.26,-155.707 h -238.11 v 526.86",
    style: {
      fill: "#232221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "m 3683.87,527.629 h 117.16 l 101.29,-253.988 102.8,253.988 h 117.17 L 3897.78,0 h -115.65 l 61.23,139.852 -159.49,387.777",
    style: {
      fill: "#232221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "m 5068.09,210.59 c -75.06,0 -108.6,48.57 -108.6,108.469 0,59.902 35.11,108.472 108.6,108.472 69.32,0 108.6,-48.57 108.6,-108.472 0,-59.899 -36.19,-108.469 -108.6,-108.469 z m 0,316.48 c -130.95,0 -208.27,-93.129 -208.27,-208.011 0,-114.887 74.23,-208.008 208.27,-208.008 115.02,0 182.67,102.539 182.67,217.379 0,78.019 -54.6,198.64 -182.67,198.64",
    style: {
      fill: "#232221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M 4702.61,648.801 V 319.77 l -254.1,329.031 h -104.27 v -526.66 h 113.39 v 335.191 l 201.06,-256.371 c 53.3,25.84 109.58,49.16 149.34,60.73 l 7.98,2.329 v 384.781 h -113.4",
    style: {
      fill: "#232221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "m 4816.01,122.141 v 112.148 c -62.1,-18.078 -166.47,-66.129 -232.39,-105.73 -2.36,-1.418 -4.66,-2.809 -6.92,-4.2 -1.2,-0.73 -2.36,-1.468 -3.55,-2.218 h 242.86",
    style: {
      fill: "#f4c80d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M 6604.87,527.07 H 6480.84 L 6405.7,412.281 6320.95,527.07 h -124 L 6343.69,324.602 6216.13,122.141 h 124.02 l 65.55,110.937 75.14,-110.937 h 124.03 L 6467.7,324.602 6604.87,527.07",
    style: {
      fill: "#232221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M 5638.77,527.07 5535.04,284.32 5429.64,527.07 H 5310.35 L 5480.48,156.672 5426.76,30.8984 h 108.48 L 5755.36,527.07 h -116.59",
    style: {
      fill: "#232221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "m 5196.14,122.141 h 86.45 V 527.07 h -86.45 L 5184,455.488 V 196.129 l 12.14,-73.988",
    style: {
      fill: "#232221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "m 5946.86,210.59 c -75.03,0 -108.58,48.57 -108.58,108.469 0,59.902 35.1,108.472 108.58,108.472 69.33,0 108.61,-48.57 108.61,-108.472 0,-59.899 -36.17,-108.469 -108.61,-108.469 z m 0,316.48 c -130.95,0 -208.26,-93.129 -208.26,-208.011 0,-114.887 74.23,-208.008 208.26,-208.008 115.04,0 182.68,102.539 182.68,217.379 0,78.019 -54.6,198.64 -182.68,198.64",
    style: {
      fill: "#232221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    d: "m 6074.92,122.141 h 86.46 V 527.07 h -86.46 l -12.15,-71.582 V 196.129 l 12.15,-73.988",
    style: {
      fill: "#232221",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(0.13333333,0,0,-0.13333333,0,471.08)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyteIcon);
export default __webpack_public_path__ + "static/media/syteIcon.fb15b26661345e684deac3dc03c7768d.svg";
export { ForwardRef as ReactComponent };